import * as React from 'react';
import Fancybox from './fancybox';


import './galery.scss';


  export default function Galery(){

    return(
        <>
          <section id="project-section">
            <div className='galery-row'>
                <h1>Galeria de fotos</h1>
              <Fancybox>
                <div className="container galery-photos">
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/planta_beneficiamento/1024x768/1.jpg">
                    <img alt="" src="https://gruposeculos.com.br/files/planta_beneficiamento/300x320/1.jpg" className='img-fluid'
                      data-aos="fade-zoom-in" 
                      data-aos-duration="1000"
                      data-aos-delay="300"
                      data-aos-offse="0"
                    />
                  </a>
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/planta_beneficiamento/1024x768/2.jpg">
                    <img alt="" src="https://gruposeculos.com.br/files/planta_beneficiamento/300x320/2.jpg" className='img-fluid'
                      data-aos="fade-zoom-in" 
                      data-aos-duration="1000"
                      data-aos-delay="300"
                      data-aos-offse="0"
                    />
                  </a>
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/planta_beneficiamento/1024x768/3.jpg">
                    <img alt="" src="https://gruposeculos.com.br/files/planta_beneficiamento/300x320/3.jpg" className='img-fluid'
                    data-aos="fade-zoom-in" 
                    data-aos-duration="1000"
                    data-aos-delay="300"
                    data-aos-offse="0"
                    />
                  </a>
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/planta_beneficiamento/1024x768/4.jpg">
                    <img alt="" src="https://gruposeculos.com.br/files/planta_beneficiamento/300x320/4.jpg" className='img-fluid' 
                      data-aos="fade-zoom-in" 
                      data-aos-duration="1000"
                      data-aos-delay="300"
                      data-aos-offse="0"
                    />
                  </a>
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/planta_beneficiamento/1024x768/5.jpg">
                    <img alt="" src="https://gruposeculos.com.br/files/planta_beneficiamento/300x320/5.jpg" className='img-fluid'
                      data-aos="fade-zoom-in" 
                      data-aos-duration="1000"
                      data-aos-delay="300"
                      data-aos-offse="0"
                    />
                  </a>
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/planta_beneficiamento/300x320/6.jpg">
                    
                    <img alt="" src="https://gruposeculos.com.br/files/planta_beneficiamento/300x320/6.jpg" className='img-fluid'
                      data-aos="fade-zoom-in"
                      data-aos-duration="1000"
                      data-aos-delay="300"
                      data-aos-offse="0"
                    />
                  </a>
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/planta_beneficiamento/300x320/7.jpg">
                    
                    <img alt="" src="https://gruposeculos.com.br/files/planta_beneficiamento/300x320/7.jpg" className='img-fluid'
                      data-aos="fade-zoom-in" 
                      data-aos-duration="1000"
                      data-aos-delay="300"
                      data-aos-offse="0"
                    />
                  </a>
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/planta_beneficiamento/300x320/8.jpg">
                    
                    <img alt="" src="https://gruposeculos.com.br/files/planta_beneficiamento/300x320/8.jpg" className='img-fluid'
                      data-aos="fade-zoom-in" 
                      data-aos-duration="1000"
                      data-aos-delay="300"
                      data-aos-offse="0"
                    />
                  </a>
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/planta_beneficiamento/1024x768/9.jpg">
                    
                    <img alt="" src="https://gruposeculos.com.br/files/planta_beneficiamento/300x320/9.jpg" className='img-fluid'
                      data-aos="fade-zoom-in" 
                      data-aos-duration="1000"
                      data-aos-delay="300"
                      data-aos-offse="0"
                    />
                  </a>
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/planta_beneficiamento/300x320/10.jpg">
                    
                    <img alt="" src="https://gruposeculos.com.br/files/planta_beneficiamento/300x320/10.jpg" className='img-fluid'
                      data-aos="fade-zoom-in" 
                      data-aos-duration="1000"
                      data-aos-delay="300"
                      data-aos-offse="0"
                    />
                  </a>
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/planta_beneficiamento/300x320/11.jpg">
                    
                    <img alt="" src="https://gruposeculos.com.br/files/planta_beneficiamento/300x320/11.jpg" className='img-fluid'
                      data-aos="fade-zoom-in" 
                      data-aos-duration="1000"
                      data-aos-delay="300"
                      data-aos-offse="0"
                    />
                  </a>
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/planta_beneficiamento/1024x768/12.jpg">
                    
                    <img alt="" src="https://gruposeculos.com.br/files/planta_beneficiamento/300x320/12.jpg" className='img-fluid'
                      data-aos="fade-zoom-in" 
                      data-aos-duration="1000"
                      data-aos-delay="300"
                      data-aos-offse="0"
                    />
                  </a>
                </div>
              </Fancybox>
            </div>
          </section>
        </>
    )
}

